import React, { useContext } from "react";
import { GlobalContext } from "../Context/GlobalState";

import AdminSidebar from "./AdminSidebar";
import HrSidebar from "./HrSidebar";
import EmployeeSidebar from "./EmployeeSidebar";
import SuperAdminSidebar from "./SuperAdminSidebar";

const Sidebar = () => {
  const { user } = useContext(GlobalContext);
  const userType = user?.us_type || JSON.parse(sessionStorage.getItem("user"))?.us_type || "G";

  switch (userType) {
    case "A":
      return <AdminSidebar />;
    case "H":
      return <HrSidebar />;
    case "E":
      return <EmployeeSidebar />;
    case "S":
      return <SuperAdminSidebar />;
    default:
      return <div>No Sidebar for this user type</div>;
  }
};

export default Sidebar;
